import React, { useCallback, useContext, useState, useEffect } from 'react';
import { Spinner } from '../../StyledComponent';
import Paginacao from '../../Paginacao';
import { ReactComponent as AlertIcon } from '../../../assets/novosicones/Financeiro/warning_amber_black_24dp.svg';

import ResumoModal from './resumoModal';
import ResumoModalMobile from './ResumoModalMobile';
import CardPayment from '../CardPayment/index';
import verificaSeParcelaAtrasada from '../../../Utils/checkIfBillIsLate';
import { ContextPagamentoCartao } from '../../../services/pagamentoCartao';
import { ContextoListaApartamentos } from '../../ApartamentList/contextoImoveis';
import ContainerCardsAntecipacaoParcelas from './ContainerCardsAntecipacaoParcelas';
import DocToSign from './DocToSign';
import { ContextoFinanceiro } from '../../../services/financeiro';
import BlockParcells from './BlockParcells';

const ParcelasAPagar = ({
  contratoSelecionado,
  parcelasSelecionadas,
  setParcelasSelecionadas,
  consultaDescontoAntecipacao,
  codOcorrencia,
  parcelasAPagar,
  gerarBoleto,
  gerarPix,
  getParcelas,
  loading,
  valoresAntecipacaoParcelas,
  isWithinOperatingPaymentPeriod,
  setshowParcelasPagas,
  setshowParcelasPagar,
}) => {
  const { openModalCardPayment } = useContext(ContextPagamentoCartao);
  const { tema } = useContext(ContextoListaApartamentos);
  const { dadosDocSign, setDadosDocSign } = useContext(ContextoFinanceiro);

  const [
    isTodasParcelasAtrasadasSelecionadas,
    setIsCheckedSelecionarTodasParcelasAtrasadas,
  ] = useState(false);

  const [
    isTodasParcelasValidasSelecionadas,
    setIsCheckedSelecionarTodasParcelasValidas,
  ] = useState(false);

  const [parcelasValidas, setParcelasValidas] = useState([]);
  const [parcelasAtrasadas, setParcelasAtrasadas] = useState([]);

  //filtra e seta as parcelas validas
  const filterParcelasValidas = () => {
    const parcelasValidasFiltradas = parcelasAPagar.filter(
      (parcela) =>
        !verificaSeParcelaAtrasada(parcela?.dataVencimento) &&
        !parcela.temBoleto &&
        !parcela.temCartao &&
        parcela.exibirGeraBoleto
    );

    const parcelasValidasWithIndex = addIndexToParcelas(
      parcelasValidasFiltradas
    );

    setParcelasValidas(parcelasValidasWithIndex);
  };

  //filtra e seta as parcelas atrasadas
  const filterParcelasAtrasadas = () => {
    const parcelasAtrasadasFiltradas = parcelasAPagar.filter(
      (parcela) =>
        verificaSeParcelaAtrasada(parcela?.dataVencimento) &&
        !parcela.temBoleto &&
        !parcela.temCartao &&
        parcela.exibirGeraBoleto
    );

    const parcelasAtrasadasWithIndex = addIndexToParcelas(
      parcelasAtrasadasFiltradas
    );

    setParcelasAtrasadas(parcelasAtrasadasWithIndex);
  };

  //adiciona index as parcelas que é utilizado na hora de adicionar ou remover uma parcela
  const addIndexToParcelas = (arrayParcelas) => {
    const parcelasWithIndex = arrayParcelas.map((parcela) => {
      return { parcela, index: parcela.numeroParcelaGeral };
    });
    return parcelasWithIndex;
  };

  //executada ao clicar no checkbox de selecionar parcelas validas
  const handleSelecionarTodasParcelasValidas = () => {
    if (parcelasSelecionadas.length === parcelasValidas.length) {
      setIsCheckedSelecionarTodasParcelasValidas(false);
      setParcelasSelecionadas([]);
    } else {
      setParcelasSelecionadas(parcelasValidas);
      setIsCheckedSelecionarTodasParcelasValidas(true);
    }
  };

  //executada ao clicar no checkbox de selecionar parcelas atrasadas
  const handleSelecionarTodasParcelasAtrasadas = () => {
    if (parcelasSelecionadas.length === parcelasAtrasadas.length) {
      setIsCheckedSelecionarTodasParcelasAtrasadas(false);
      setParcelasSelecionadas([]);
    } else {
      setParcelasSelecionadas(parcelasAtrasadas);
      setIsCheckedSelecionarTodasParcelasAtrasadas(true);
    }
  };

  //verifica se há parcelas vencidas
  const haParcelasVencidas = useCallback(() => {
    if (parcelasSelecionadas.length > 0) {
      return verificaSeParcelaAtrasada(
        parcelasSelecionadas[0].parcela.dataVencimento
      );
    }
  }, [parcelasSelecionadas]);

  useEffect(() => {
    if (parcelasAPagar) {
      filterParcelasValidas();
      filterParcelasAtrasadas();
    }
  }, [parcelasAPagar]);

  useEffect(() => {
    const lengthParcelasSelecionadas = parcelasSelecionadas.length;

    if (lengthParcelasSelecionadas > 0) {
      const isVencidas = haParcelasVencidas();

      // se quantidade de parcelas atrasadas for igual a de selecionadas e forem vencidas
      if (
        parcelasAtrasadas.length === lengthParcelasSelecionadas &&
        isVencidas
      ) {
        setIsCheckedSelecionarTodasParcelasAtrasadas(true);
      } else {
        setIsCheckedSelecionarTodasParcelasAtrasadas(false);
      }

      // se quantidade de parcelas validas for igual a de selecionadas e forem validas
      if (
        parcelasValidas.length === lengthParcelasSelecionadas &&
        !isVencidas
      ) {
        setIsCheckedSelecionarTodasParcelasValidas(true);
      } else {
        setIsCheckedSelecionarTodasParcelasValidas(false);
      }
    } else {
      setIsCheckedSelecionarTodasParcelasValidas(false);
      setIsCheckedSelecionarTodasParcelasAtrasadas(false);
    }
  }, [parcelasSelecionadas]);

  if (loading) return <Spinner />;

  if (dadosDocSign?.habilitarFinanceiro && parcelasAPagar.length == 0)
    return (
      <div
        style={{ width: '100%', textAlign: 'center' }}
        className='centralized-column'
      >
        <div
          style={{ width: '80%', textAlign: 'left' }}
          className='centralized'
        >
          <AlertIcon />{' '}
          <p style={{ marginLeft: '15px' }}>
            <b>
              No momento não há registros para exibir,{' '}
              <span
                onClick={() => {
                  getParcelas();
                }}
                style={{
                  color: '#0047BA',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                clique aqui para atualizar
              </span>{' '}
              ou entre em contato com nossa central de relacionamento para mais
              informações.
            </b>
          </p>
        </div>
      </div>
    );

  return (
    <>
      {!isWithinOperatingPaymentPeriod &&
        !dadosDocSign?.bannerAditivo?.showBannerAditivo && (
          <BlockParcells
            tema={tema}
            setshowParcelasPagas={setshowParcelasPagas}
            setshowParcelasPagar={setshowParcelasPagar}
          />
        )}
      {dadosDocSign?.bannerAditivo?.showBannerAditivo && (
        <DocToSign
          tema={tema}
          contratoSelecionado={contratoSelecionado}
          getParcelas={getParcelas}
          dadosDocSign={dadosDocSign}
          setDadosDocSign={setDadosDocSign}
        />
      )}
      {dadosDocSign?.habilitarFinanceiro && isWithinOperatingPaymentPeriod && (
        <>
          <ContainerCardsAntecipacaoParcelas
            valoresAntecipacaoParcelas={valoresAntecipacaoParcelas}
            tema={tema}
          />

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
              width: 'fit-content',
              marginTop: 16,
            }}
          >
            <label style={{ cursor: 'pointer' }}>
              <input
                type='checkbox'
                checked={isTodasParcelasAtrasadasSelecionadas}
                onChange={handleSelecionarTodasParcelasAtrasadas}
                disabled={
                  haParcelasVencidas() === false ||
                  isTodasParcelasValidasSelecionadas
                }
                style={{ marginRight: 16 }}
                id={'inputSelecionarTodasParcelasVencidas'}
              />
              Selecionar todas parcelas vencidas
            </label>
            <label style={{ cursor: 'pointer' }}>
              <input
                type='checkbox'
                checked={isTodasParcelasValidasSelecionadas}
                onChange={handleSelecionarTodasParcelasValidas}
                disabled={
                  haParcelasVencidas() || isTodasParcelasAtrasadasSelecionadas
                }
                style={{ marginRight: 16 }}
                id={'inputSelecionarTodasParcelasAVencer'}
              />
              Selecionar todas parcelas a vencer
            </label>
          </div>
        </>
      )}

      {parcelasSelecionadas.length > 0 && !gerarBoleto && !gerarPix && (
        <>
          <ResumoModal
            parcelasSelecionadas={parcelasSelecionadas}
            consultaDescontoAntecipacao={consultaDescontoAntecipacao}
            tema={tema}
            contratoSelecionado={contratoSelecionado}
          />
          <ResumoModalMobile
            parcelasSelecionadas={parcelasSelecionadas}
            consultaDescontoAntecipacao={consultaDescontoAntecipacao}
            tema={tema}
            contratoSelecionado={contratoSelecionado}
          />
        </>
      )}
      {dadosDocSign?.habilitarFinanceiro && isWithinOperatingPaymentPeriod && (
        <Paginacao
          parcelas={parcelasAPagar}
          setParcelasSelecionadas={setParcelasSelecionadas}
          parcelasSelecionadas={parcelasSelecionadas}
          tema={tema}
          tipo='aPagar'
          codOcorrencia={codOcorrencia}
          parcelasAPagar={parcelasAPagar}
          handleSelecionarTodasParcelasAtrasadas={
            handleSelecionarTodasParcelasAtrasadas
          }
        />
      )}

      {openModalCardPayment && (
        <CardPayment
          tema={tema}
          getParcelas={getParcelas}
          setParcelasSelecionadas={setParcelasSelecionadas}
        />
      )}
    </>
  );
};

export default ParcelasAPagar;
